import { NotificationAreaDTO } from '../models/NotificationArea'
import { TicketRepository } from '../repositories/TicketRepository'

export function CreateNotificationAreaAssociationCase(
  ticketRepository: TicketRepository
) {
  return async function (data: NotificationAreaDTO) {
    return await ticketRepository.createNotificationAreaAssociation(data)
  }
}
